import type { Group } from "../../types/models";

export function findLeastFullGroup(groups: Group[]): Group | undefined {
    if (groups.length === 0) return undefined;

    let minGroup = groups[0];
    let minSize = minGroup!.memberIds.length;

    for (const group of groups) {
        if (group.memberIds.length < minSize) {
            minGroup = group;
            minSize = group.memberIds.length;
        }
    }

    return minGroup;
}
